<template>
    <app-content>
        <div class="col-6 h-100 overflow-auto">
            <el-collapse class="w-100">
                <el-collapse-item v-for="(item,index) in jsonFiles" :key="index">
                    <template slot="title">
                        <div class="ml-1">{{ item.name }}</div>
                    </template>
                    <el-collapse class="w-100">
                        <el-collapse-item v-for="file in item.jsonFiles" :key="file.name">
                            <template slot="title">
                                <div class="ml-2" style="color: #3579f6">{{ file.name }}</div>
                            </template>
                            <div class="d-flex flex-column">
                                <div v-for="cell in file.content" class="d-flex flex-row cell">
                                    <div class="ml-3 mt-1"
                                         :class="selectedEntity.has(cell.entityName) ? 'badge badge-warning' : ''"
                                         @click="cellClick(cell.entityName)">
                                        {{ cell.entityName }}
                                    </div>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div class="col ml-2 d-flex flex-column">
            <h4>selected entity:</h4>
            <div v-for="entity of Array.from(selectedEntity)">
                {{ entity }}
            </div>
            <div class="mt-auto">
                <b-button variant="outline-primary" @click="download('common')">common</b-button>
                <b-button class="ml-2" variant="outline-primary" @click="download('server')">server</b-button>
                <b-button class="ml-2" variant="outline-primary" @click="download('frontend')">frontend</b-button>
            </div>
        </div>
    </app-content>
</template>

<script>
import AppContent from "@/components/echarts-part/stuff/AppContent";
import AvatarButton from "@/components/echarts-part/CalendarShift/cells/stuffs/AvatarButton";
import axios from "axios";

export default {
    name: "CodeGenerationHelper",
    components: {AvatarButton, AppContent},
    data() {
        return {
            jsonFiles: [],
            selectedEntity: new Set(),
            downloading: false
        }
    },
    mounted() {
        this.getRemoteJson();
    },
    methods: {
        getRemoteJson() {
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_EM_BASE_CODE_GENERATION_URL + "/jsonFiles"
            }).then(response => {
                let tempList = [];
                for (let dir of response) {
                    let moduleList = [];
                    for (let module of dir.jsonFiles) {
                        let cellList = [];
                        for (let cell of module.content) {
                            cellList.push(JSON.parse(cell));
                        }
                        moduleList.push({
                            name: module.name,
                            content: cellList
                        });
                    }
                    tempList.push({
                        name: dir.name,
                        jsonFiles: moduleList
                    });
                }
                this.jsonFiles = tempList;
                console.log(tempList)
            })
        },
        cellClick(entity) {
            if (this.selectedEntity.has(entity)) {
                this.selectedEntity.delete(entity);
            } else {
                this.selectedEntity.add(entity);
            }
            this.$forceUpdate();
        },
        download(type) {
            if (this.selectedEntity.size > 0) {
                this.downloading = true;

                let tempList = [];
                for (let dir of this.jsonFiles) {
                    if (dir.name.endsWith(type)) {
                        for (let module of dir.jsonFiles) {
                            for (let cell of module.content) {
                                if (this.selectedEntity.has(cell.entityName)) {
                                    tempList.push(cell);
                                }
                            }
                        }
                    }
                }
                console.log(tempList);

                // this.$store.dispatch('api/post', {
                //     url: process.env.VUE_APP_EM_BASE_CODE_GENERATION_URL + "/" + type,
                //     data: JSON.stringify(tempList),
                // }).then(response => {
                //     console.log(response)
                // });

                let jwt = localStorage['em_sso_token']
                if (jwt != null) {
                    axios.post(process.env.VUE_APP_EM_BASE_CODE_GENERATION_URL + "/" + type,
                        JSON.stringify(tempList), {
                            responseType: 'blob',
                            headers: {
                                'Content-Type': "application/json;charset=UTF-8",
                                'Authorization': jwt,
                                'Access-Control-Allow-Credentials': true,
                                'Access-Control-Allow-Origin': 'http://localhost:8080'
                            }
                        }).then(res => {
                        console.log('res',res)
                        let link = document.createElement('a');
                        let blob = new Blob([res.data]);
                        console.log('blob',blob)
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        // link.href = window.URL.createObjectURL(res.data);
                        link.setAttribute('download', type + ".zip");
                        // document.body.appendChild(link);
                        link.click();
                        // document.body.removeChild(link);
                        window.URL.revokeObjectURL(link.href);
                    });
                }

                // this.$store.dispatch('api/postReportDownload', {
                //     url: process.env.VUE_APP_EM_BASE_CODE_GENERATION_URL + "/" + type,
                //     data: JSON.stringify(tempList),
                // })

            }
        }
    }
}
</script>

<style scoped>
.cell {
    height: 23px;
}
</style>